/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type TagPicker_relayDevices = {|
  +edges: ?$ReadOnlyArray<?{|
    +node: ?{|
      +id: string;
      +tags: ?$ReadOnlyArray<?string>;
    |};
  |}>;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TagPicker_relayDevices",
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "DeviceEdge",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Device",
          "name": "node",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            },
            {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tags",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DeviceConnection"
};

module.exports = fragment;



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/components/ReportHeader/components/ReportFilters/components/TagPicker/__generated__/TagPicker_relayDevices.graphql.js